// extracted by mini-css-extract-plugin
export default {"top":"index_top__PEvc7","bottom":"index_bottom__wbZiv","show":"index_show__cBxCP","ansewer":"index_ansewer__6JHh-","answerControl":"index_answerControl__-BrIz"};